import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Stopwatch — the hand sweeps second-hand style, 60° every 1 s for a
 *  crisp mechanical tick rather than a smooth sweep. */
export function IcnStopwatch(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="stopwatch">
      {/* Top stem + crown */}
      <line x1="6.5" y1="1.5" x2="9.5" y2="1.5" />
      <line x1="8" y1="1.5" x2="8" y2="3" />
      <line x1="11" y1="2.7" x2="12" y2="3.7" />
      {/* Case */}
      <circle cx="8" cy="9" r="5.5" />
      {/* Tick marks */}
      <line x1="8" y1="4.5" x2="8" y2="5.3" />
      <line x1="8" y1="12.7" x2="8" y2="13.5" />
      <line x1="3.5" y1="9" x2="4.3" y2="9" />
      <line x1="11.7" y1="9" x2="12.5" y2="9" />
      {/* Second hand — rotates in 1s ticks around case centre */}
      <g style={{ transformOrigin: '8px 9px' }}>
        {animate && (
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0;60;120;180;240;300;360"
            keyTimes="0;0.166;0.333;0.5;0.666;0.833;1"
            calcMode="discrete"
            dur="6s"
            repeatCount="indefinite"
          />
        )}
        <line x1="8" y1="9" x2="8" y2="5.5" />
      </g>
      <circle cx="8" cy="9" r="0.7" fill="currentColor" stroke="none" />
    </Svg>
  );
}
